import { hexToRgb } from './hexToRgb'

export const hexToRgba = (hex: string, a = 1) => {
  if (!hex) return null
  const rbg = hexToRgb(hex)
  return rbg ? `${rbg}, ${a}` : null
}
